import Vue from 'vue'
import Vuex from 'vuex'
import createMutationsSharer from './multiTab'
import RouterUtils from '@/router/RouterUtils'

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createMutationsSharer({predicate: ['login', 'logout']})],
  state: {
    accessToken: JSON.parse(localStorage.getItem('access-token') ? localStorage.getItem('access-token') : JSON.stringify('')),
    refreshToken: JSON.parse(localStorage.getItem('refresh-token') ? localStorage.getItem('refresh-token') : JSON.stringify('')),
    roles: JSON.parse(localStorage.getItem('roles') ? localStorage.getItem('roles') : JSON.stringify([])),
    practiceQuestionIds: localStorage.getItem('practiceQuestionIds') ? localStorage.getItem('practiceQuestionIds') : JSON.stringify([]),
    loadingProcesses: 0
  },
  mutations: {
    login (state, value) {
      state.accessToken = value.access_token
      state.refreshToken = value.refresh_token
      state.roles = value.roles
      localStorage.setItem('access-token', JSON.stringify(value.access_token))
      localStorage.setItem('refresh-token', JSON.stringify(value.refresh_token))
      localStorage.setItem('roles', JSON.stringify(value.roles))
      if (value.fromLogonService) {
        RouterUtils.push('Index')
      }
    },
    logout (state, value) {
      state.accessToken = ''
      state.refreshToken = ''
      state.roles = []
      localStorage.setItem('access-token', '')
      localStorage.setItem('refresh-token', '')
      localStorage.setItem('roles', '')
      if (value && value.fromLogonService) {
        RouterUtils.push('Index')
      }
    },
    setPracticeQuestionIds (state, value) {
      let s = JSON.stringify(value)
      state.practiceQuestionIds = s
      localStorage.setItem('practiceQuestionIds', s)
    },
    startLoading (state) {
      state.loadingProcesses++
    },
    endLoading (state) {
      state.loadingProcesses--
    }
  },
  actions: {
    login (context, data) {
      context.commit('login', data)
    },
    logout (context, data) {
      context.commit('logout', data)
    },
    setPracticeQuestionIds (context, ids) {
      context.commit('setPracticeQuestionIds', ids)
    },
    loading (context, value) {
      value ? context.commit('startLoading') : context.commit('endLoading')
    }
  },
  getters: {
    getAccessToken (state) {
      return state.accessToken
    },
    getRefreshToken (state) {
      return state.refreshToken
    },
    getRoles (state) {
      return state.roles
    },
    getPracticeQuestionIds (state) {
      return JSON.parse(state.practiceQuestionIds)
    },
    isLoading (state) {
      return state.loadingProcesses > 0
    },
    isAuthenticated (state) {
      return !!state.accessToken
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js